var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomeCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.283,
    height: 14.998,
    viewBox: "0 0 19.283 14.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-credit-card",
    "data-name": "Icon awesome-credit-card",
    d: "M0,15.641a1.607,1.607,0,0,0,1.607,1.607H17.676a1.607,1.607,0,0,0,1.607-1.607V9.749H0Zm6.428-2.276a.4.4,0,0,1,.4-.4h4.553a.4.4,0,0,1,.4.4V14.7a.4.4,0,0,1-.4.4H6.829a.4.4,0,0,1-.4-.4Zm-4.285,0a.4.4,0,0,1,.4-.4h2.41a.4.4,0,0,1,.4.4V14.7a.4.4,0,0,1-.4.4H2.544a.4.4,0,0,1-.4-.4Zm17.14-9.507V5.464H0V3.857A1.607,1.607,0,0,1,1.607,2.25H17.676A1.607,1.607,0,0,1,19.283,3.857Z",
    transform: "translate(0 -2.25)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeCreditCard);
export default __webpack_public_path__ + "static/media/Icon awesome-credit-card.1182aaab175e85b50ecf3439e60e0b9f.svg";
export { ForwardRef as ReactComponent };